import { render, staticRenderFns } from "./Sticker.vue?vue&type=template&id=f4737ab6&scoped=true"
import script from "./Sticker.vue?vue&type=script&lang=js"
export * from "./Sticker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4737ab6",
  null
  
)

export default component.exports